import { getApi } from '../apiClient';
import { IMeetingsResponse } from './types';

export async function getMeetings(params: {
  searchValue?: string;
  page?: IMeetingsResponse['currentPage'];
  startTime?: string;
  endTime?: string;
  perPage?: string;
}): Promise<IMeetingsResponse> {
  const { page, searchValue, startTime, endTime, perPage } = params;
  const { data } = await getApi().get<IMeetingsResponse>('/meetings', {
    params: {
      page,
      ...(searchValue && { 'q[title_start]': searchValue }),
      ...(startTime && { 'q[start_time_gt]': startTime }),
      ...(endTime && { 'q[end_time_lt]': endTime }),
      ...(perPage && { per_page: perPage })
    }
  });

  return data;
}
